import { DocumentNode, gql } from '@apollo/client'

export const ADD_DAYCARE_MEAL_MENU: DocumentNode = gql`
    mutation addDaycareMealMenu($daycareId: Int!, $menu: String!) {
        addDaycareMealMenu(daycareId: $daycareId, menu: $menu)
    }
`

export const DELETE_DAYCARE_MEAL_MENU: DocumentNode = gql`
    mutation deleteDaycareMealMenu($daycareId: Int!, $id: Int!) {
        deleteDaycareMealMenu(daycareId: $daycareId, menuId: $id)
    }
`

export const ADD_DAYCARE_MEAL_HABIT: DocumentNode = gql`
    mutation addDaycareMealHabit($daycareId: Int!, $habit: String!) {
        addDaycareMealHabit(daycareId: $daycareId, habit: $habit)
    }
`

export const DELETE_DAYCARE_MEAL_HABIT: DocumentNode = gql`
    mutation deleteDaycareMealHabit($daycareId: Int!, $id: Int!) {
        deleteDaycareMealHabit(daycareId: $daycareId, habitId: $id)
    }
`

export const ADD_DAYCARE_MEAL_TEXTURE: DocumentNode = gql`
    mutation addDaycareMealTexture($daycareId: Int!, $texture: String!) {
        addDaycareMealTexture(daycareId: $daycareId, texture: $texture)
    }
`

export const DELETE_DAYCARE_MEAL_TEXTURE: DocumentNode = gql`
    mutation deleteDaycareMealTexture($daycareId: Int!, $id: Int!) {
        deleteDaycareMealTexture(daycareId: $daycareId, textureId: $id)
    }
`

export const UPDATE_DAYCARE_MEAL_MENU: DocumentNode = gql`
    mutation updateDaycareMealMenu($daycareId: Int!, $menuId: Int!, $menu: String!) {
        updateDaycareMealMenu(daycareId: $daycareId, menuId: $menuId, menu: $menu)
    }
`

export const UPDATE_DAYCARE_MEAL_HABIT: DocumentNode = gql`
    mutation updateDaycareMealHabit($daycareId: Int!, $habitId: Int!, $habit: String!) {
        updateDaycareMealHabit(daycareId: $daycareId, habitId: $habitId, habit: $habit)
    }
`

export const UPDATE_DAYCARE_MEAL_TEXTURE: DocumentNode = gql`
    mutation updateDaycareMealTexture($daycareId: Int!, $textureId: Int!, $texture: String!) {
        updateDaycareMealTexture(daycareId: $daycareId, textureId: $textureId, texture: $texture)
    }
`

export const ADD_DAYCARE_MEAL_ACCESSIBILITY: DocumentNode = gql`
    mutation addDaycareMealAccessibilitySection(
        $daycareId: Int!
        $sectionIds: [Int]!
        $start: Time!
        $type: MealType!
    ) {
        addDaycareMealAccessibilitySection(daycareId: $daycareId, sectionIds: $sectionIds, start: $start, type: $type)
    }
`
export const UPDATE_DAYCARE_MEAL_ACCESSIBILITY: DocumentNode = gql`
    mutation updateDaycareMealAccessibilitySection(
        $daycareId: Int!
        $sectionId: Int!
        $start: Time!
        $accessibilitySectionId: Int!
        $type: MealType!
    ) {
        updateDaycareMealAccessibilitySection(
            daycareId: $daycareId
            sectionId: $sectionId
            start: $start
            accessibilitySectionId: $accessibilitySectionId
            type: $type
        )
    }
`
export const DELETE_DAYCARE_MEAL_ACCESSIBILITY: DocumentNode = gql`
    mutation deleteDaycareMealAccessibilitySection($daycareId: Int!, $accessibilitySectionId: Int!, $sectionId: Int!) {
        deleteDaycareMealAccessibilitySection(
            daycareId: $daycareId
            accessibilitySectionId: $accessibilitySectionId
            sectionId: $sectionId
        )
    }
`

export const UPDATE_MEAL_DETAIL_QUANTITY: DocumentNode = gql`
    mutation updateMealDetailQuantity(
        $daycareId: Int!
        $sectionIds: [Int]!
        $date: Date!
        $menuIds: [Int]!
        $textureIds: [Int]!
        $habitIds: [Int]!
        $action: String!
        $mealType: MealType!
    ) {
        updateMealDetailQuantity(
            daycareId: $daycareId
            sectionIds: $sectionIds
            date: $date
            menuIds: $menuIds
            textureIds: $textureIds
            habitIds: $habitIds
            action: $action
            mealType: $mealType
        )
    }
`

export const FREEZE_MEAL_DETAIL: DocumentNode = gql`
    mutation freezeMealDetail(
        $daycareId: Int!
        $sectionIds: [Int]!
        $date: Date!
        $freeze: Boolean!
        $mealTypes: [MealType]!
        $orderAdjustments: [OrderAdjustmentInput]
    ) {
        freezeMealDetail(
            daycareId: $daycareId
            sectionIds: $sectionIds
            date: $date
            freeze: $freeze
            mealTypes: $mealTypes
            orderAdjustments: $orderAdjustments
        )
    }
`
